import {
  GET_ANONYMOUS_EXAM_RECORDS,
  GET_ANONYMOUS_EXAM_RECORDS_FAIL,
  GET_ANONYMOUS_EXAM_RECORDS_SUCCESS,
  ADD_NEW_ANONYMOUS_EXAM_RECORD,
  ADD_ANONYMOUS_EXAM_RECORD_SUCCESS,
  ADD_ANONYMOUS_EXAM_RECORD_FAIL,
  UPDATE_ANONYMOUS_EXAM_RECORD,
  UPDATE_ANONYMOUS_EXAM_RECORD_SUCCESS,
  UPDATE_ANONYMOUS_EXAM_RECORD_FAIL,
  DELETE_ANONYMOUS_EXAM_RECORD,
  DELETE_ANONYMOUS_EXAM_RECORD_SUCCESS,
  DELETE_ANONYMOUS_EXAM_RECORD_FAIL,

  GET_ANONYMOUS_RECORDS_FOR_TEACHER,
  GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS,
  GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAIL,


  // LAST ADD FOR SEARCH BY BARCODE
  GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE,
  GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_SUCCESS,
  GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_FAIL,
  UPDATE_ANONYMOUS_EXAM_RECORD_NOTE,
  UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_SUCCESS,
  UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_FAIL,

  // FOR GENERATE ANONYMOUS RECORDS
  GENERATE_ANONYMOUS_RECORDS,
  GENERATE_ANONYMOUS_RECORDS_SUCCESS,
  GENERATE_ANONYMOUS_RECORDS_FAIL
  
} from "./actionTypes";

/*
export const getAnonymousExamRecords = () => ({
  type: GET_ANONYMOUS_EXAM_RECORDS,
})
  */

// Récupération (payload contiendra { evaluation_uuid, ...filters })
export const getAnonymousExamRecords = (payload) => ({
  type: GET_ANONYMOUS_EXAM_RECORDS,
  payload,
});


export const getAnonymousExamRecordsSuccess = (anonymousExamRecords) => ({
  type: GET_ANONYMOUS_EXAM_RECORDS_SUCCESS,
  payload: anonymousExamRecords,
})

export const getAnonymousExamRecordsFail = error => ({
  type: GET_ANONYMOUS_EXAM_RECORDS_FAIL,
  payload: error,
})

export const addNewAnonymousExamRecord = data => ({
  type: ADD_NEW_ANONYMOUS_EXAM_RECORD,
  payload: data,
})

export const addAnonymousExamRecordSuccess = (anonymousExamRecord) => ({
  type: ADD_ANONYMOUS_EXAM_RECORD_SUCCESS,
  payload: anonymousExamRecord,
})

export const addAnonymousExamRecordFail = error => ({
  type: ADD_ANONYMOUS_EXAM_RECORD_FAIL,
  payload: error,
})

export const updateAnonymousExamRecord = (anonymousExamRecord) => ({
  type: UPDATE_ANONYMOUS_EXAM_RECORD,
  payload: anonymousExamRecord,
})

export const updateAnonymousExamRecordSuccess = (anonymousExamRecord) => ({
  type: UPDATE_ANONYMOUS_EXAM_RECORD_SUCCESS,
  payload: anonymousExamRecord,
})

export const updateAnonymousExamRecordFail = error => ({
  type: UPDATE_ANONYMOUS_EXAM_RECORD_FAIL,
  payload: error,
})

export const deleteAnonymousExamRecord = data => ({
  type: DELETE_ANONYMOUS_EXAM_RECORD,
  payload: data,
})

export const deleteAnonymousExamRecordSuccess = data => ({
  type: DELETE_ANONYMOUS_EXAM_RECORD_SUCCESS,
  payload: data,
})

export const deleteAnonymousExamRecordFail = error => ({
  type: DELETE_ANONYMOUS_EXAM_RECORD_FAIL,
  payload: error,
})

export const resetAnonymousExamRecordLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});

// Action pour lancer la récupération (optionnel : payload = { barcode })
export const getAnonymousRecordsForTeacher = (filters) => ({
  type: GET_ANONYMOUS_RECORDS_FOR_TEACHER,
  payload: filters,
});

// Action success
export const getAnonymousRecordsForTeacherSuccess = (anonymousExamRecords) => ({
  type: GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS,
  payload: anonymousExamRecords,
});

// Action fail
export const getAnonymousRecordsForTeacherFail = (error) => ({
  type: GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAIL,
  payload: error,
});


// LAST ADD FOR SEARCH BY BARCODE
export const getAnonymousExamRecordByBarcode = (barcode) => ({
    type: GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE,
    payload: barcode
});

export const getAnonymousExamRecordByBarcodeSuccess = (record) => ({
    type: GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_SUCCESS,
    payload: record
});

export const getAnonymousExamRecordByBarcodeFail = (error) => ({
    type: GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_FAIL,
    payload: error
});

export const updateAnonymousExamRecordNote = (data) => ({
    type: UPDATE_ANONYMOUS_EXAM_RECORD_NOTE,
    payload: data
});

export const updateAnonymousExamRecordNoteSuccess = (record) => ({
    type: UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_SUCCESS,
    payload: record
});

export const updateAnonymousExamRecordNoteFail = (error) => ({
    type: UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_FAIL,
    payload: error
});

// FOR GENERATE ANONYMOUS RECORDS
export const generateAnonymousRecords = (evaluationUuid) => ({
    type: GENERATE_ANONYMOUS_RECORDS,
    payload: evaluationUuid,
});

export const generateAnonymousRecordsSuccess = data => ({
    type: GENERATE_ANONYMOUS_RECORDS_SUCCESS,
    payload: data,
});

export const generateAnonymousRecordsFail = error => ({
    type: GENERATE_ANONYMOUS_RECORDS_FAIL,
    payload: error,
});
